import type { CategoryPerformanceStats } from '@/types/miniApp'

export function CategoryPerformanceCard({
  title,
  stats,
  variant = 'ai',
}: {
  title: string
  stats?: CategoryPerformanceStats | null
  variant?: 'ai' | 'safest'
}) {
  const isSafest = variant === 'safest'
  // Win Rate/ROI solo tienen sentido si hay al menos un pick DECIDIDO (ganado o perdido)
  // -- un pick void no basta para tener muestra, aunque cuente como "liquidado".
  const hasSample = Boolean(stats && stats.decided_picks > 0)

  const winRateText = hasSample && stats?.win_rate != null ? `${stats.win_rate.toFixed(1)}%` : 'N/D'
  const roiText = hasSample && stats?.roi != null ? `${stats.roi >= 0 ? '+' : ''}${stats.roi.toFixed(1)}%` : 'N/D'
  const settledCount = stats ? stats.settled_picks : 0
  const wins = stats ? stats.wins : 0
  const losses = stats ? stats.losses : 0
  const voids = stats ? stats.voids : 0
  const avgOddsText = hasSample && stats?.average_odds != null ? `@${stats.average_odds.toFixed(2)}` : 'N/D'

  return (
    <div
      className={`p-4 rounded-2xl border shadow-md space-y-3 ${
        isSafest
          ? 'bg-gradient-to-br from-emerald-950/40 via-panel to-panel border-emerald-500/40'
          : 'bg-gradient-to-br from-brand-soft/20 via-panel to-panel border-brand/40'
      }`}
    >
      <div className="flex items-center justify-between border-b border-border/40 pb-2">
        <h3 className={`text-xs font-black uppercase tracking-wider ${isSafest ? 'text-emerald-400' : 'text-brand'}`}>
          {title}
        </h3>
        {!hasSample && (
          <span className="text-[10px] font-extrabold px-2 py-0.5 rounded-full bg-panel-elevated text-text-dim border border-border/50">
            Muestra insuficiente
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-panel-elevated/40 p-2.5 rounded-xl border border-border/30">
          <span className="text-[9px] font-bold uppercase tracking-wider text-text-dim block">Win Rate</span>
          <span className={`text-lg font-mono font-black ${isSafest ? 'text-emerald-400' : 'text-brand'}`}>
            {winRateText}
          </span>
        </div>

        <div className="bg-panel-elevated/40 p-2.5 rounded-xl border border-border/30">
          <span className="text-[9px] font-bold uppercase tracking-wider text-text-dim block">ROI</span>
          <span className={`text-lg font-mono font-black ${isSafest ? 'text-emerald-400' : 'text-brand'}`}>
            {roiText}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 text-center text-xs font-mono pt-1">
        <div className="bg-panel-elevated/30 p-2 rounded-lg">
          <span className="text-[9px] font-bold text-text-dim block">Liquidados</span>
          <span className="font-black text-text">{settledCount}</span>
        </div>
        <div className="bg-panel-elevated/30 p-2 rounded-lg">
          <span className="text-[9px] font-bold text-text-dim block">G / P{voids > 0 ? ' / Ø' : ''}</span>
          <span className="font-black text-text">
            {wins} / {losses}
            {voids > 0 ? ` / ${voids}` : ''}
          </span>
        </div>
        <div className="bg-panel-elevated/30 p-2 rounded-lg">
          <span className="text-[9px] font-bold text-text-dim block">Cuota Med.</span>
          <span className="font-black text-text">{avgOddsText}</span>
        </div>
      </div>
    </div>
  )
}
